(function () {
  'use strict';

  var MOBILE_BP = 768;
  var TOC_BP = 1100;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isDesktop() { return window.innerWidth >= MOBILE_BP; }
  function isTocViewport() { return window.innerWidth >= TOC_BP; }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ---------- TOC scroll-spy + smooth scroll (desktop only) ---------- */
  var tocState = {
    initialized: false,
    observer: null,
    clickHandlers: [], // [{link, handler}]
    links: [],
    targets: []
  };

  function initTOC() {
    var toc = document.querySelector('[data-Advertorial-Lander-toc]');
    if (!toc) return;
    if (!isTocViewport()) return;
    if (tocState.initialized) return;

    var links = Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;

    var targets = links
      .map(function (link) {
        var id = link.getAttribute('href').slice(1);
        var el = id ? document.getElementById(id) : null;
        return el ? { link: link, el: el } : null;
      })
      .filter(Boolean);

    // Smooth scroll
    links.forEach(function (link) {
      var handler = function (e) {
        var id = link.getAttribute('href').slice(1);
        var el = document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      };
      link.addEventListener('click', handler);
      tocState.clickHandlers.push({ link: link, handler: handler });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var match = targets.filter(function (t) { return t.el === entry.target; })[0];
          if (!match) return;
          links.forEach(function (l) {
            l.classList.remove('is-active');
            l.removeAttribute('aria-current');
          });
          match.link.classList.add('is-active');
          match.link.setAttribute('aria-current', 'location');
        });
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });

      targets.forEach(function (t) { observer.observe(t.el); });
      tocState.observer = observer;
    }

    tocState.links = links;
    tocState.targets = targets;
    tocState.initialized = true;
  }

  function teardownTOC() {
    if (!tocState.initialized) return;
    if (tocState.observer) {
      try { tocState.observer.disconnect(); } catch (e) {}
      tocState.observer = null;
    }
    tocState.clickHandlers.forEach(function (h) {
      try { h.link.removeEventListener('click', h.handler); } catch (e) {}
    });
    tocState.clickHandlers = [];
    tocState.links.forEach(function (l) {
      l.classList.remove('is-active');
      l.removeAttribute('aria-current');
    });
    tocState.links = [];
    tocState.targets = [];
    tocState.initialized = false;
  }

  function handleResize() {
    if (isTocViewport()) {
      if (!tocState.initialized) initTOC();
    } else {
      if (tocState.initialized) teardownTOC();
    }
  }

  window.addEventListener('resize', debounce(handleResize, 250));

  /* ---------- Sticky offer bar ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-Advertorial-Lander-sticky]');
    if (!bar) return;

    // Page-scoped dismissal only — reload restores the bar
    var dismissed = false;

    var closeBtn = bar.querySelector('[data-Advertorial-Lander-sticky-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dismissed = true;
        bar.classList.add('is-dismissed');
        bar.classList.remove('is-visible');
      });
    }

    // Pause video if reduced motion
    var video = bar.querySelector('video');
    if (video && reduceMotion) {
      try { video.pause(); } catch (e) {}
    }

    var heroScrolledPast = false;
    var finalCtaInView = false;

    function showBar() {
      if (dismissed) return;
      if (!heroScrolledPast) return;
      if (finalCtaInView) return;
      bar.classList.add('is-visible');
    }
    function hideBar() { bar.classList.remove('is-visible'); }

    // Sentinel at end of hero (absolutely positioned, guaranteed to cross viewport)
    var sentinel = document.querySelector('[data-Advertorial-Lander-sticky-sentinel]');
    var sentinelIOWired = false;

    if (sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            heroScrolledPast = true;
            showBar();
          } else if (entry.isIntersecting) {
            heroScrolledPast = false;
            hideBar();
          }
        });
      }, { threshold: 0 });
      io.observe(sentinel);
      sentinelIOWired = true;
    }

    // Belt-and-suspenders scroll fallback (always wired) — handles edge cases
    // where the sentinel might not move on very tall viewports.
    var threshold = parseInt(bar.getAttribute('data-show-after') || '600', 10);
    window.addEventListener('scroll', function () {
      if (!sentinelIOWired) {
        if (window.scrollY > threshold) { heroScrolledPast = true; showBar(); }
        else { heroScrolledPast = false; hideBar(); }
      } else if (window.scrollY > threshold && !heroScrolledPast) {
        // Sentinel never fired but user has clearly scrolled past hero
        heroScrolledPast = true;
        showBar();
      }
    }, { passive: true });

    // Bidirectional collision detection: hide when final CTA enters viewport,
    // re-show when it leaves (unless dismissed).
    var finalCta = document.querySelector('[data-Advertorial-Lander-final-cta]');
    if (finalCta && 'IntersectionObserver' in window) {
      var collisionIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            finalCtaInView = true;
            hideBar();
          } else {
            finalCtaInView = false;
            showBar();
          }
        });
      }, { threshold: 0.2 });
      collisionIO.observe(finalCta);
    }
  }

  /* ---------- Swiper init (testimonial carousel) ---------- */
  function initSwiper() {
    var nodes = document.querySelectorAll('[data-Advertorial-Lander-swiper]');
    if (!nodes.length) return;
    if (typeof window.Swiper === 'undefined') {
      // Swiper script may still be loading (defer); retry once on window load.
      window.addEventListener('load', function () {
        if (typeof window.Swiper === 'undefined') return;
        nodes.forEach(function (n) {
          if (n.dataset.swiperInit === '1') return;
          n.dataset.swiperInit = '1';
          new window.Swiper(n, { slidesPerView: 1, pagination: { el: n.querySelector('.swiper-pagination'), clickable: true }, spaceBetween: 24 });
        });
      });
      return;
    }
    nodes.forEach(function (n) {
      if (n.dataset.swiperInit === '1') return;
      n.dataset.swiperInit = '1';
      new window.Swiper(n, { slidesPerView: 1, pagination: { el: n.querySelector('.swiper-pagination'), clickable: true }, spaceBetween: 24 });
    });
  }

  /* ---------- Hide TOC when scrolling past Benefits Grid ---------- */
  function initTocAutoHide() {
    var toc = document.querySelector('[data-Advertorial-Lander-toc]');
    if (!toc) return;
    // Find the benefits grid section (first dark-bg full-width section after articles)
    var benefitsGrid = document.querySelector('.Advertorial-Lander-benefits');
    if (!benefitsGrid) return;
    if (!('IntersectionObserver' in window)) return;

    var tocHidden = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Hide when benefits grid enters viewport from below (scrolling down)
        if (entry.isIntersecting) {
          toc.style.opacity = '0';
          toc.style.pointerEvents = 'none';
          tocHidden = true;
        }
      });
    }, { threshold: 0 });
    io.observe(benefitsGrid);

    // Use scroll to detect when user scrolls back above benefits grid
    window.addEventListener('scroll', function () {
      var rect = benefitsGrid.getBoundingClientRect();
      if (rect.top > window.innerHeight && tocHidden) {
        toc.style.opacity = '1';
        toc.style.pointerEvents = 'auto';
        tocHidden = false;
      } else if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        toc.style.opacity = '0';
        toc.style.pointerEvents = 'none';
        tocHidden = true;
      }
    }, { passive: true });
  }

  function init() {
    initTOC();
    initTocAutoHide();
    initStickyBar();
    initSwiper();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
